import { SubPlanAssociationItemType } from '../../../../modules/customer-accounts/pages/sub-plan-associations/enums/subPlanAssociationItemType';
import { SubscriptionPlanModel } from 'src/app/models/subscription-plan/SubscriptionPlanModel';
import { UserModel } from 'src/app/models/users/UserModel';
import { VehicleModel } from 'src/app/models/vehicles/VehicleModel';

export class ModalEditSubPlanData {
    itemType: SubPlanAssociationItemType;
    subscriptionPlan: SubscriptionPlanModel;
    item: UserModel | VehicleModel;
}
